module.exports = __webpack_public_path__ + "static/media/introducing-WPKT-logo.5e8ca12c.png";